import HBox from '../../layout/container/h_box/HBox';
import React from 'react';
import { PUZZLE_FAKE_CHECKBOX_PROPS } from './Types';
import { PureComponent } from '../../../dispatcher/modules';
import classNames from 'classnames';

export default class PuzzleFakeCheckbox extends PureComponent<PUZZLE_FAKE_CHECKBOX_PROPS> {
  constructor(props: any) {
    super(props);
  }

  static defaultProps = {
    checked: false
  }

  render() {
    let {
      checked,
      label,
      additionalIcon,
      additionalButtons
    } = this.props;
    if (React.isValidElement(label)) {
      label = label.key;
    }
    const cls = classNames(
      'tp-fake-checkbox', {
        'checked': checked
      }
    );
    return (
      <HBox
        role={'checkbox'}
        alignItemsStart
        ariaChecked={checked ? 'true' : 'false'}
        className={cls}
      >
        <i
          aria-hidden={'true'}
          className={`tp-icon ${checked ? 'tp-checked-checkbox-filled' : 'tp-checkbox-outline'}`}
        />
        {additionalIcon &&
        <i
          aria-hidden={'true'}
          className={`tp-icon ${additionalIcon}`}
        />
        }
        <div className={'tp-fake-checkbox-label'}>{label}</div>
        {additionalButtons}
      </HBox>
    );
  }
}
